var _path, _g, _path2, _g2, _rect, _g3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8511 6H37.9924H12.1336C7.94587 6 7 21 7 21H13.9338H38H62.0662H69C69 21 68.0541 6 63.8511 6Z",
    fill: "#301C6B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_5983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4541 14.5313 44.3229 14.7538 54.1294C14.8305 57.4238 16.7405 60.4679 19.8318 62.2055L29.9726 67.9254C34.8895 70.6915 41.1105 70.6915 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4307 61.2462 54.1364C61.4687 44.3298 61.7908 26.4541 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "#302E66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_979_5983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 52,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4542 14.5313 44.3229 14.7538 54.1295C14.8305 57.4238 16.7405 60.468 19.8318 62.2055L29.9726 67.9254C34.8895 70.6916 41.1105 70.6916 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4308 61.2462 54.1364C61.4687 44.3298 61.7908 26.4542 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_979_5983)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_979_5983)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.8329,
    ry: 24.4889,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.5006 -4.10358)",
    fill: "#944FD8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_979_5983)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 28.9048,
    ry: 35.6905,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.6406 92.9653)",
    fill: "#3AF0F0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_979_5983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 32,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_979_5983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5977 34.1982C38.5977 34.3767 38.453 34.5214 38.2745 34.5214L35.3456 34.5214C34.7039 34.5214 34.2421 34.5216 33.8794 34.5513C33.5205 34.5806 33.2871 34.6371 33.0973 34.7338C32.7305 34.9207 32.4323 35.2189 32.2454 35.5857C32.1487 35.7755 32.0922 36.0089 32.0629 36.3678C32.0332 36.7305 32.033 37.1923 32.033 37.834L32.033 39.4777L32.9962 38.5144C33.1224 38.3882 33.327 38.3882 33.4532 38.5144C33.5794 38.6407 33.5794 38.8453 33.4532 38.9715L31.9383 40.4864C31.8777 40.547 31.7955 40.5811 31.7098 40.5811C31.6241 40.5811 31.5419 40.547 31.4813 40.4864L29.9663 38.9715C29.8401 38.8453 29.8401 38.6407 29.9663 38.5144C30.0925 38.3882 30.2972 38.3882 30.4234 38.5144L31.3866 39.4777L31.3866 37.8195C31.3866 37.1954 31.3866 36.7073 31.4186 36.3152C31.4512 35.9163 31.5186 35.5884 31.6695 35.2922C31.9183 34.8038 32.3154 34.4067 32.8038 34.1579C33.1 34.007 33.4279 33.9396 33.8268 33.907C34.2189 33.875 34.7071 33.875 35.3311 33.875L38.2745 33.875C38.453 33.875 38.5977 34.0197 38.5977 34.1982Z",
    fill: "url(#paint0_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8477 52.7295C37.8477 52.5511 37.9924 52.4064 38.1708 52.4064L41.0997 52.4064C41.7414 52.4064 42.2032 52.4061 42.5659 52.3765C42.9248 52.3472 43.1582 52.2907 43.3481 52.1939C43.7148 52.007 44.013 51.7088 44.1999 51.3421C44.2966 51.1522 44.3531 50.9188 44.3825 50.5599C44.4121 50.1972 44.4123 49.7354 44.4123 49.0937L44.4123 47.4501L43.4491 48.4133C43.3229 48.5395 43.1183 48.5395 42.9921 48.4133C42.8659 48.2871 42.8659 48.0825 42.9921 47.9562L44.507 46.4413C44.5676 46.3807 44.6498 46.3467 44.7355 46.3467C44.8212 46.3467 44.9034 46.3807 44.9641 46.4413L46.479 47.9562C46.6052 48.0825 46.6052 48.2871 46.479 48.4133C46.3528 48.5395 46.1481 48.5395 46.0219 48.4133L45.0587 47.4501L45.0587 49.1082C45.0587 49.7323 45.0587 50.2204 45.0267 50.6125C44.9941 51.0115 44.9267 51.3393 44.7758 51.6355C44.527 52.1239 44.1299 52.521 43.6415 52.7698C43.3453 52.9208 43.0174 52.9881 42.6185 53.0207C42.2264 53.0527 41.7383 53.0527 41.1142 53.0527L38.1708 53.0527C37.9924 53.0527 37.8477 52.908 37.8477 52.7295Z",
    fill: "url(#paint1_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9143 45.2628C33.4337 45.2628 33.9531 45.2583 34.4726 45.2674C34.5629 45.2674 34.6804 45.3125 34.7436 45.3802C35.1637 45.7909 35.5837 46.2016 35.9857 46.6304C37.1511 47.8715 37.5169 49.3293 36.9884 50.945C36.4645 52.5562 35.3308 53.5491 33.655 53.8696C30.9314 54.3886 28.3975 52.1184 28.5872 49.3563C28.6594 48.3048 29.0614 47.4066 29.7841 46.6529C30.1997 46.2196 30.6243 45.7909 31.0579 45.3712C31.1211 45.308 31.2385 45.2674 31.3334 45.2674C31.8573 45.2583 32.3858 45.2628 32.9143 45.2628ZM31.496 50.3086C31.5502 50.9901 31.9251 51.3828 32.571 51.5633C32.571 51.7845 32.571 52.0011 32.571 52.2177C32.8014 52.2177 33.0046 52.2177 33.235 52.2177C33.235 52.0733 33.244 51.9469 33.2305 51.8206C33.2079 51.631 33.2621 51.5362 33.4653 51.473C34.0119 51.297 34.3551 50.7238 34.2874 50.1642C34.2196 49.5685 33.7589 49.1081 33.1627 49.0449C33.0046 49.0269 32.8465 49.0359 32.6884 49.0224C32.3948 48.9908 32.178 48.7471 32.1735 48.4627C32.1645 48.1739 32.3723 47.9256 32.6613 47.876C33.1988 47.7812 33.4292 47.9076 33.6505 48.4356C33.8583 48.4356 34.0661 48.4356 34.3326 48.4356C34.2558 48.21 34.2061 48.0069 34.1158 47.8264C33.9351 47.4698 33.6054 47.2938 33.2305 47.19C33.2305 47.1133 33.2305 47.0546 33.2305 46.9914C33.2305 46.4543 33.2305 46.4498 32.702 46.5085C32.6478 46.513 32.571 46.5988 32.562 46.6529C32.5439 46.8289 32.5575 47.0095 32.5575 47.1855C32.4852 47.208 32.4355 47.2261 32.3858 47.2442C31.7896 47.4427 31.4192 48.0114 31.505 48.6026C31.5909 49.2255 32.0787 49.6678 32.7155 49.7039C32.851 49.7129 32.9865 49.7039 33.1221 49.7219C33.4156 49.7625 33.6189 50.0153 33.6144 50.3041C33.6099 50.593 33.3931 50.8322 33.104 50.8728C32.5529 50.9495 32.3406 50.8276 32.1419 50.3086C31.9341 50.3086 31.7264 50.3086 31.496 50.3086Z",
    fill: "url(#paint2_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3623 42.3877C32.0606 42.3877 33.7364 42.3877 35.4302 42.3877C35.1953 43.0286 34.9514 43.6514 34.7346 44.2787C34.6533 44.5134 34.5539 44.5992 34.2919 44.5947C33.3299 44.5766 32.3633 44.5811 31.4012 44.5901C31.2341 44.5901 31.1482 44.5495 31.0895 44.3825C30.8637 43.7236 30.6107 43.0647 30.3623 42.3877Z",
    fill: "url(#paint3_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2167 42.3582C40.9412 42.3841 39.0541 40.4663 39.0606 38.1826C39.067 35.928 40.9477 34.0297 43.2361 34.0361C45.4922 34.0394 47.3955 35.928 47.3826 38.2279C47.3696 40.4825 45.489 42.3938 43.2167 42.3582ZM45.1524 36.5078C45.1394 36.4106 45.0909 36.3329 44.9905 36.2908C44.8675 36.2389 44.7834 36.3037 44.7024 36.3815C43.6019 37.4829 42.4981 38.5843 41.3976 39.6889C41.2649 39.8217 41.2584 39.948 41.362 40.0582C41.4688 40.1651 41.5983 40.1618 41.731 40.029C42.838 38.9244 43.9418 37.8165 45.0455 36.7119C45.1038 36.6536 45.1491 36.5953 45.1524 36.5078ZM42.9934 36.9905C42.9901 36.4527 42.5499 36.0122 42.0126 36.0154C41.4882 36.0187 41.0286 36.4851 41.0351 37.0067C41.0448 37.5444 41.485 37.972 42.0288 37.972C42.579 37.9688 42.9966 37.5477 42.9934 36.9905ZM43.4465 39.3973C43.4465 39.9513 43.8608 40.3692 44.4144 40.3692C44.9679 40.3692 45.3854 39.948 45.3854 39.3973C45.3854 38.8402 44.9711 38.4255 44.4144 38.4255C43.8641 38.4288 43.4465 38.8434 43.4465 39.3973Z",
    fill: "url(#paint4_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0161 36.5049C42.2977 36.5017 42.5178 36.722 42.5178 37.0038C42.5146 37.2759 42.301 37.4929 42.0258 37.4962C41.7475 37.4994 41.5273 37.2791 41.5273 36.9973C41.5306 36.722 41.741 36.5082 42.0161 36.5049Z",
    fill: "url(#paint5_linear_979_5983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4204 38.9053C44.702 38.9053 44.9189 39.1321 44.9124 39.4139C44.9059 39.686 44.6891 39.8998 44.4139 39.8998C44.1323 39.8998 43.9187 39.6763 43.9219 39.3912C43.9284 39.1159 44.1453 38.9021 44.4204 38.9053Z",
    fill: "url(#paint6_linear_979_5983)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0179 20.063C23.6039 20.063 23.2319 19.991 22.9019 19.847C22.5779 19.697 22.3229 19.493 22.1369 19.235C21.9509 18.971 21.8549 18.668 21.8489 18.326H22.7219C22.7519 18.62 22.8719 18.869 23.0819 19.073C23.2979 19.271 23.6099 19.37 24.0179 19.37C24.4079 19.37 24.7139 19.274 24.9359 19.082C25.1639 18.884 25.2779 18.632 25.2779 18.326C25.2779 18.086 25.2119 17.891 25.0799 17.741C24.9479 17.591 24.7829 17.477 24.5849 17.399C24.3869 17.321 24.1199 17.237 23.7839 17.147C23.3699 17.039 23.0369 16.931 22.7849 16.823C22.5389 16.715 22.3259 16.547 22.1459 16.319C21.9719 16.085 21.8849 15.773 21.8849 15.383C21.8849 15.041 21.9719 14.738 22.1459 14.474C22.3199 14.21 22.5629 14.006 22.8749 13.862C23.1929 13.718 23.5559 13.646 23.9639 13.646C24.5519 13.646 25.0319 13.793 25.4039 14.087C25.7819 14.381 25.9949 14.771 26.0429 15.257H25.1429C25.1129 15.017 24.9869 14.807 24.7649 14.627C24.5429 14.441 24.2489 14.348 23.8829 14.348C23.5409 14.348 23.2619 14.438 23.0459 14.618C22.8299 14.792 22.7219 15.038 22.7219 15.356C22.7219 15.584 22.7849 15.77 22.9109 15.914C23.0429 16.058 23.2019 16.169 23.3879 16.247C23.5799 16.319 23.8469 16.403 24.1889 16.499C24.6029 16.613 24.9359 16.727 25.1879 16.841C25.4399 16.949 25.6559 17.12 25.8359 17.354C26.0159 17.582 26.1059 17.894 26.1059 18.29C26.1059 18.596 26.0249 18.884 25.8629 19.154C25.7009 19.424 25.4609 19.643 25.1429 19.811C24.8249 19.979 24.4499 20.063 24.0179 20.063ZM28.3102 15.743V18.65C28.3102 18.89 28.3612 19.061 28.4632 19.163C28.5652 19.259 28.7422 19.307 28.9942 19.307H29.5972V20H28.8592C28.4032 20 28.0612 19.895 27.8332 19.685C27.6052 19.475 27.4912 19.13 27.4912 18.65V15.743H26.8522V15.068H27.4912V13.826H28.3102V15.068H29.5972V15.743H28.3102ZM30.2835 17.516C30.2835 17.012 30.3855 16.571 30.5895 16.193C30.7935 15.809 31.0725 15.512 31.4265 15.302C31.7865 15.092 32.1855 14.987 32.6235 14.987C33.0555 14.987 33.4305 15.08 33.7485 15.266C34.0665 15.452 34.3035 15.686 34.4595 15.968V15.068H35.2875V20H34.4595V19.082C34.2975 19.37 34.0545 19.61 33.7305 19.802C33.4125 19.988 33.0405 20.081 32.6145 20.081C32.1765 20.081 31.7805 19.973 31.4265 19.757C31.0725 19.541 30.7935 19.238 30.5895 18.848C30.3855 18.458 30.2835 18.014 30.2835 17.516ZM34.4595 17.525C34.4595 17.153 34.3845 16.829 34.2345 16.553C34.0845 16.277 33.8805 16.067 33.6225 15.923C33.3705 15.773 33.0915 15.698 32.7855 15.698C32.4795 15.698 32.2005 15.77 31.9485 15.914C31.6965 16.058 31.4955 16.268 31.3455 16.544C31.1955 16.82 31.1205 17.144 31.1205 17.516C31.1205 17.894 31.1955 18.224 31.3455 18.506C31.4955 18.782 31.6965 18.995 31.9485 19.145C32.2005 19.289 32.4795 19.361 32.7855 19.361C33.0915 19.361 33.3705 19.289 33.6225 19.145C33.8805 18.995 34.0845 18.782 34.2345 18.506C34.3845 18.224 34.4595 17.897 34.4595 17.525ZM39.4255 20L37.4905 17.822V20H36.6715V13.34H37.4905V17.255L39.3895 15.068H40.5325L38.2105 17.525L40.5415 20H39.4255ZM41.7264 14.267C41.5704 14.267 41.4384 14.213 41.3304 14.105C41.2224 13.997 41.1684 13.865 41.1684 13.709C41.1684 13.553 41.2224 13.421 41.3304 13.313C41.4384 13.205 41.5704 13.151 41.7264 13.151C41.8764 13.151 42.0024 13.205 42.1044 13.313C42.2124 13.421 42.2664 13.553 42.2664 13.709C42.2664 13.865 42.2124 13.997 42.1044 14.105C42.0024 14.213 41.8764 14.267 41.7264 14.267ZM42.1224 15.068V20H41.3034V15.068H42.1224ZM45.9212 14.978C46.5212 14.978 47.0072 15.161 47.3792 15.527C47.7512 15.887 47.9372 16.409 47.9372 17.093V20H47.1272V17.21C47.1272 16.718 47.0042 16.343 46.7582 16.085C46.5122 15.821 46.1762 15.689 45.7502 15.689C45.3182 15.689 44.9732 15.824 44.7152 16.094C44.4632 16.364 44.3372 16.757 44.3372 17.273V20H43.5182V15.068H44.3372V15.77C44.4992 15.518 44.7182 15.323 44.9942 15.185C45.2762 15.047 45.5852 14.978 45.9212 14.978ZM51.309 14.987C51.735 14.987 52.107 15.08 52.425 15.266C52.749 15.452 52.989 15.686 53.145 15.968V15.068H53.973V20.108C53.973 20.558 53.877 20.957 53.685 21.305C53.493 21.659 53.217 21.935 52.857 22.133C52.503 22.331 52.089 22.43 51.615 22.43C50.967 22.43 50.427 22.277 49.995 21.971C49.563 21.665 49.308 21.248 49.23 20.72H50.04C50.13 21.02 50.316 21.26 50.598 21.44C50.88 21.626 51.219 21.719 51.615 21.719C52.065 21.719 52.431 21.578 52.713 21.296C53.001 21.014 53.145 20.618 53.145 20.108V19.073C52.983 19.361 52.743 19.601 52.425 19.793C52.107 19.985 51.735 20.081 51.309 20.081C50.871 20.081 50.472 19.973 50.112 19.757C49.758 19.541 49.479 19.238 49.275 18.848C49.071 18.458 48.969 18.014 48.969 17.516C48.969 17.012 49.071 16.571 49.275 16.193C49.479 15.809 49.758 15.512 50.112 15.302C50.472 15.092 50.871 14.987 51.309 14.987ZM53.145 17.525C53.145 17.153 53.07 16.829 52.92 16.553C52.77 16.277 52.566 16.067 52.308 15.923C52.056 15.773 51.777 15.698 51.471 15.698C51.165 15.698 50.886 15.77 50.634 15.914C50.382 16.058 50.181 16.268 50.031 16.544C49.881 16.82 49.806 17.144 49.806 17.516C49.806 17.894 49.881 18.224 50.031 18.506C50.181 18.782 50.382 18.995 50.634 19.145C50.886 19.289 51.165 19.361 51.471 19.361C51.777 19.361 52.056 19.289 52.308 19.145C52.566 18.995 52.77 18.782 52.92 18.506C53.07 18.224 53.145 17.897 53.145 17.525Z",
    fill: "#F7F7FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_5983",
    x: 0,
    y: 0,
    width: 76,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_5983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_5983",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_979_5983",
    x: -15.9883,
    y: -53.9365,
    width: 108.978,
    height: 99.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_979_5983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_979_5983",
    x: -17.0498,
    y: 44.0605,
    width: 111.381,
    height: 97.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_979_5983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_5983",
    x1: 38.5977,
    y1: 37.228,
    x2: 29.8717,
    y2: 37.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_5983",
    x1: 37.8477,
    y1: 49.6997,
    x2: 46.5736,
    y2: 49.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_979_5983",
    x1: 32.9012,
    y1: 45.2617,
    x2: 32.9012,
    y2: 53.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_979_5983",
    x1: 32.8962,
    y1: 42.3877,
    x2: 32.8962,
    y2: 44.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_979_5983",
    x1: 43.2216,
    y1: 34.0361,
    x2: 43.2216,
    y2: 42.3586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_979_5983",
    x1: 42.0226,
    y1: 36.5049,
    x2: 42.0226,
    y2: 37.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_979_5983",
    x1: 44.4172,
    y1: 38.9053,
    x2: 44.4172,
    y2: 39.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeTag);
export default __webpack_public_path__ + "static/media/stakeTag.b6830be97ddff4d13d2f3b40af6fa5ab.svg";
export { ForwardRef as ReactComponent };